import { ID_CARD_PORTRAIT, ID_CARD_LANDSCAPE, ID_CARD_DESIGNS } from './idCardTheme';

export const CARD_FORMAT_OPTIONS = [
  { value: 'portrait', label: ID_CARD_PORTRAIT.label },
  { value: 'landscape', label: ID_CARD_LANDSCAPE.label },
];

export function layoutKeyToCardFormat(layoutKey) {
  return parseIdCardLayoutKey(layoutKey).format;
}

export function parseIdCardLayoutKey(layoutKey) {
  const key = String(layoutKey || '').toLowerCase().trim();
  if (key === 'portrait') return { design: 'saffron', format: 'portrait' };
  if (key === 'landscape') return { design: 'saffron', format: 'landscape' };

  const parts = key.split('_').filter(Boolean);
  if (parts.length >= 2) {
    const format = parts[parts.length - 1];
    const design = parts.slice(0, -1).join('_');
    if ((format === 'portrait' || format === 'landscape') && design) {
      return {
        design: ID_CARD_DESIGNS[design] ? design : 'saffron',
        format,
      };
    }
  }

  return { design: 'saffron', format: 'portrait' };
}

export function parseIdCardTemplate(template) {
  if (!template) {
    return { design: 'saffron', format: 'portrait', templateId: '' };
  }
  const { design, format } = parseIdCardLayoutKey(template.layout_key);
  return {
    design,
    format,
    templateId: template.id || '',
  };
}

export function cardFormatFromTemplate(template) {
  return parseIdCardTemplate(template).format;
}

export function designFromTemplate(template) {
  return parseIdCardTemplate(template).design;
}

export function findTemplateById(templates, id) {
  if (!id || !templates?.length) return null;
  return templates.find((t) => String(t.id) === String(id)) || null;
}

export function cardFormatLabel(format) {
  return CARD_FORMAT_OPTIONS.find((o) => o.value === format)?.label || format;
}

export function groupTemplatesByDesign(templates) {
  const groups = {};
  (templates || []).forEach((t) => {
    const { design } = parseIdCardTemplate(t);
    if (!groups[design]) {
      groups[design] = {
        design,
        label: ID_CARD_DESIGNS[design]?.label || design,
        swatch: ID_CARD_DESIGNS[design]?.swatch || '#888',
        templates: [],
      };
    }
    groups[design].templates.push(t);
  });
  return Object.values(groups).sort((a, b) => {
    const order = ['saffron', 'navy', 'emerald'];
    return order.indexOf(a.design) - order.indexOf(b.design);
  });
}
